var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-signature", {
        staticClass: "mw-100 mb-0",
        attrs: { text: _vm.title },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "accordion" },
        _vm._l(_vm.questionList, function (question, index) {
          return _c(
            "div",
            { key: "question-" + index },
            [
              _c(
                "ob1-expanding-accordion-card",
                {
                  attrs: {
                    "collapsed-block-id": "collapse-" + index,
                    "link-id": "question-" + index,
                    "link-title": question.title,
                    "is-card-body-max-width": false,
                  },
                },
                [_c("div", { domProps: { innerHTML: _vm._s(question.text) } })]
              ),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }